export const thinkificConstants = {
  CREATE_DISCOUNT_CODES_REQUEST: "THINKIFIC_CREATE_DISCOUNT_CODES_REQUEST",
  CREATE_DISCOUNT_CODES_SUCCESS: "THINKIFIC_CREATE_DISCOUNT_CODES_SUCCESS",
  CREATE_DISCOUNT_CODES_FAILURE: "THINKIFIC_CREATE_DISCOUNT_CODES_FAILURE",
  LIST_DISCOUNT_CODES_REQUEST: "THINKIFIC_LIST_DISCOUNT_CODES_REQUEST",
  LIST_DISCOUNT_CODES_SUCCESS: "THINKIFIC_LIST_DISCOUNT_CODES_SUCCESS",
  LIST_DISCOUNT_CODES_FAILURE: "THINKIFIC_LIST_DISCOUNT_CODES_FAILURE",
};